import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LinkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"link"}/>
}
